<template>
  <div class='theme-progress-container'>
    <div
      class="divider"
      v-for="item in totalUnits"
      :key="item"
      :style="{'background': item <= completedUnits ? themeProgressBackground : '' }"
    >
    </div>
  </div>
</template>

<script>

import pBarColor from 'images/progress-scribble-bar-color7.gif';

export default {
  props: {
    completedUnits: {
      type: Number
    },
    totalUnits: {
      type: Number
    }
  },

  data() {
    return {
      progressBarColor: pBarColor
    };
  },

  computed: {
    themeProgressBackground() {
      const progressBg = `url(${this.progressBarColor}) 100% 0 no-repeat`;
      return `${progressBg}`;
    }
  }

};
</script>

<style lang="scss" scoped>
  .divider {
    border-left: 2px solid #2E70BE;
  }
</style>
